<div class="daily-checkin" [class.done-view]="view === 'done'">

  <!-- DONE SCREEN -->
  <section class="screen done-screen" *ngIf="view === 'done'">
    <div class="done-greeting">
      <h1
        class="greeting-text"
        [innerHTML]="'dailyCheckin.done.greeting' | translate : { name: firstName }"
      ></h1>
      <p class="done-saved">{{ 'dailyCheckin.done.saved' | translate }}</p>
    </div>

    <div class="done-content">
      <div class="insight-card" *ngIf="doneTipKey">
        <span class="card-header">
          {{ 'wellnessTip.header' | translate }}
        </span>
        <p class="tip-text">{{ doneTipTextKey | translate }}</p>
      </div>
    </div>

    <div class="done-footer">
      <button type="button" class="finish-button" (click)="openJournal()">
        {{ 'dailyCheckin.done.viewJournal' | translate }}
      </button>
      <button type="button" class="done-secondary" (click)="finishDone()">
        {{ 'dailyCheckin.done.finish' | translate }}
      </button>
    </div>

    <div class="disclaimer-area">
      <p class="disclaimer-text">
        {{ 'wellnessTip.disclaimer' | translate }}
        <span class="emergency-note">
          {{ 'wellnessTip.emergency' | translate }}
        </span>
      </p>
    </div>
  </section>

  <!-- HOME SCREEN -->
  <section class="screen" *ngIf="view === 'home'">
    <button type="button" class="back-btn checkin-exit" (click)="exitCheckin()">
      <mat-icon class="rtl-icon">arrow_back</mat-icon>
    </button>
    <h1
      class="greeting"
      [innerHTML]="'dailyCheckin.greeting' | translate : { name: firstName }"
    ></h1>
    <p class="greeting-sub">{{ 'dailyCheckin.greetingSub' | translate }}</p>

    <div class="update-card">
      <div class="update-card-content">
        <span class="card-title">
          {{ 'dailyCheckin.dailyUpdate.title' | translate }}
        </span>
        <span class="card-subtitle">
          {{ 'dailyCheckin.dailyUpdate.subtitle' | translate }}
        </span>
      </div>
      <div class="action-row">
        <button type="button" class="choice-btn primary" (click)="startVoice()">
          <mat-icon>mic</mat-icon>
          <span>{{ 'dailyCheckin.dailyUpdate.voice' | translate }}</span>
        </button>
        <button
          type="button"
          class="choice-btn secondary"
          (click)="startWritten()"
        >
          <mat-icon>edit</mat-icon>
          <span>{{ 'dailyCheckin.dailyUpdate.typing' | translate }}</span>
        </button>
      </div>
    </div>

    <!-- quiet permanent journal entry point (§2.2) -->
    <button type="button" class="journal-link" (click)="openJournal()">
      <span class="journal-link-ico">
        <mat-icon>menu_book</mat-icon>
      </span>
      <span class="journal-link-body">
        <span class="journal-link-title">
          {{ 'dailyCheckin.journal.linkTitle' | translate }}
        </span>
        <span class="journal-link-sub">
          {{ 'dailyCheckin.journal.linkSub' | translate }}
        </span>
      </span>
      <mat-icon class="rtl-icon journal-link-arrow">keyboard_arrow_right</mat-icon>
    </button>

    <button type="button" class="full-checkin-btn" (click)="openFullCheckin()">
      <div class="full-checkin-text">
        <span class="card-title">
          {{ 'dailyCheckin.fullCheckin.title' | translate }}
        </span>
        <span class="card-subtitle">
          {{ 'dailyCheckin.fullCheckin.subtitle' | translate }}
        </span>
      </div>
      <mat-icon class="rtl-icon">keyboard_arrow_right</mat-icon>
    </button>

    <p class="home-why">{{ 'dailyCheckin.homeWhy' | translate }}</p>
  </section>

  <!-- VOICE FLOW -->
  <section class="screen" *ngIf="view === 'voice'">
    <button type="button" class="back-btn" (click)="voiceBack()">
      <mat-icon class="rtl-icon">arrow_back</mat-icon>
    </button>

    <div class="progress-dots">
      <div
        class="dot"
        *ngFor="let s of voiceSteps; let i = index"
        [class.active]="i === stepIndex"
      ></div>
    </div>

    <h2 class="screen-title">{{ currentVoiceStep.titleKey | translate }}</h2>

    <div class="prompt-card">
      <div class="prompt-instruction">
        {{ currentVoiceStep.instructionKey | translate }}
      </div>
      <ul class="prompt-parts" *ngIf="currentVoiceStep.partKeys.length">
        <li *ngFor="let p of currentVoiceStep.partKeys">{{ p | translate }}</li>
      </ul>
    </div>

    <div class="helper-box" *ngIf="currentVoiceStep.helperKey">
      {{ currentVoiceStep.helperKey | translate }}
    </div>

    <div class="record-area">
      <button
        type="button"
        class="mic-btn"
        [class.active]="voiceStatus === 'recording'"
        [class.done]="voiceStatus === 'done'"
        [class.paused]="voiceStatus === 'paused'"
        [disabled]="voiceStatus === 'transcribing' || voiceStatus === 'done'"
        (click)="onMicClick()"
        [attr.aria-label]="'dailyCheckin.mic.tapToRecord' | translate"
      >
        <mat-icon *ngIf="voiceStatus !== 'transcribing'">
          {{
            voiceStatus === 'done'
              ? 'check'
              : voiceStatus === 'recording'
              ? 'pause'
              : 'mic'
          }}
        </mat-icon>
        <mat-icon *ngIf="voiceStatus === 'transcribing'" class="spin">
          autorenew
        </mat-icon>
      </button>

      <p class="mic-status" *ngIf="voiceStatus !== 'done'">
        <ng-container [ngSwitch]="voiceStatus">
          <span *ngSwitchCase="'idle'">
            {{ 'dailyCheckin.mic.tapToRecord' | translate }}
          </span>
          <span *ngSwitchCase="'recording'">
            {{ 'dailyCheckin.mic.recording' | translate }}
          </span>
          <span *ngSwitchCase="'paused'">
            {{ 'dailyCheckin.mic.paused' | translate }}
          </span>
          <span *ngSwitchCase="'transcribing'">
            {{ 'dailyCheckin.mic.transcribing' | translate }}
          </span>
        </ng-container>
      </p>

      <div
        class="recording-controls"
        *ngIf="voiceStatus === 'recording' || voiceStatus === 'paused'"
      >
        <button
          type="button"
          class="control-btn"
          *ngIf="voiceStatus === 'paused'"
          (click)="restartRecording()"
        >
          {{ 'dailyCheckin.mic.reset' | translate }}
        </button>
        <button
          type="button"
          class="control-btn stop-btn"
          (click)="finishRecording()"
        >
          {{ 'dailyCheckin.mic.finish' | translate }}
        </button>
      </div>

      <div
        class="interim-transcript"
        *ngIf="voiceInterim && voiceStatus !== 'idle' && voiceStatus !== 'done'"
      >
        {{ voiceInterim }}
      </div>

      <div class="done-transcript" *ngIf="voiceStatus === 'done'">
        <textarea
          class="transcript-textarea"
          [(ngModel)]="voiceResults[stepIndex].transcript"
          [placeholder]="'dailyCheckin.mic.editPlaceholder' | translate"
          rows="4"
        ></textarea>
        <div class="transcript-actions kb-lift">
          <span class="edit-hint">
            {{ 'dailyCheckin.mic.editHint' | translate }}
          </span>
          <button
            type="button"
            class="rerecord-btn"
            (click)="restartRecording()"
          >
            <mat-icon>refresh</mat-icon>
            <span>{{ 'dailyCheckin.mic.recordAgain' | translate }}</span>
          </button>
        </div>
      </div>

      <div class="error-message" *ngIf="voiceError">{{ voiceError }}</div>

      <!-- B7: the transcription failed but the recording is kept, so this offers
           a real retry of the same audio rather than losing what she said. -->
      <div class="transcribe-failed" *ngIf="transcribeFailed">
        <span>{{ 'dailyCheckin.mic.transcribeFailed' | translate }}</span>
        <button type="button" class="control-btn" (click)="retryTranscription()" [disabled]="transcribeRetrying">
          {{ (transcribeRetrying ? 'dailyCheckin.mic.transcribing' : 'loader.failed.retry') | translate }}
        </button>
      </div>

      <div
        class="skip-row"
        *ngIf="currentVoiceStep.canSkip && voiceStatus === 'idle'"
        (click)="skipVoiceStep()"
      >
        <button type="button" class="skip-btn">
          {{ 'dailyCheckin.skip.label' | translate }}
        </button>
        <span class="skip-text">
          {{ 'dailyCheckin.skip.nothingUnusual' | translate }}
        </span>
      </div>
    </div>

    <div class="footer-actions kb-lift">
      <button
        type="button"
        class="next-btn"
        [disabled]="voiceStatus !== 'done' || saving"
        (click)="nextVoiceStep()"
      >
        {{
          (stepIndex === voiceSteps.length - 1
            ? 'dailyCheckin.actions.finish'
            : 'dailyCheckin.actions.continue'
          ) | translate
        }}
      </button>
    </div>
  </section>

  <!-- WRITTEN FLOW -->
  <section class="screen" *ngIf="view === 'written'">
    <button type="button" class="back-btn" (click)="writtenBack()">
      <mat-icon class="rtl-icon">arrow_back</mat-icon>
    </button>

    <div class="progress-dots">
      <div
        class="dot"
        *ngFor="let s of writtenSteps; let i = index"
        [class.active]="i === stepIndex"
      ></div>
    </div>

    <div class="section-label">
      {{ currentWrittenStep.labelKey | translate }}
    </div>
    <h2 class="screen-title">
      {{ currentWrittenStep.questionKey | translate }}
    </h2>

    <div class="sliders-container" *ngIf="currentWrittenStep.sliders?.length">
      <div
        class="slider-group"
        *ngFor="let slider of currentWrittenStep.sliders"
      >
        <div class="slider-header">
          <span class="slider-label">{{ slider.labelKey | translate }}</span>
          <span class="slider-value">
            {{ formatSliderValue(currentWrittenStep, slider) }}
          </span>
        </div>
        <input
          type="range"
          [min]="slider.min"
          [max]="slider.max"
          [value]="writtenSliderValues[currentWrittenStep.section][slider.key]"
          (input)="onSliderInput(currentWrittenStep, slider, $event)"
        />
      </div>
    </div>

    <div class="icon-grid" *ngIf="currentWrittenStep.grid?.length">
      <button
        type="button"
        class="icon-item"
        *ngFor="let item of currentWrittenStep.grid"
        [class.selected]="isTagSelected(currentWrittenStep.section, item.value)"
        (click)="toggleTag(currentWrittenStep.section, item.value)"
      >
        <mat-icon class="icon-item-icon">{{ item.icon }}</mat-icon>
        <span class="icon-item-label">{{ item.labelKey | translate }}</span>
      </button>
    </div>

    <div class="textarea-title">
      {{ currentWrittenStep.textareaTitleKey | translate }}
    </div>
    <textarea
      class="notes-textarea"
      [placeholder]="currentWrittenStep.placeholderKey | translate"
      [(ngModel)]="writtenText[currentWrittenStep.section]"
      rows="4"
    ></textarea>

    <div class="footer-actions kb-lift">
      <button
        type="button"
        class="next-btn"
        [disabled]="saving"
        (click)="nextWrittenStep()"
      >
        {{
          (stepIndex === writtenSteps.length - 1
            ? 'dailyCheckin.actions.finish'
            : 'dailyCheckin.actions.next'
          ) | translate
        }}
      </button>
    </div>
  </section>

  <!-- JOURNAL VIEW -->
  <section class="screen journal-screen" *ngIf="view === 'journal'">
    <button type="button" class="back-btn" (click)="journalBack()">
      <mat-icon class="rtl-icon">arrow_back</mat-icon>
    </button>

    <div class="journal-head">
      <h1 class="journal-title">
        {{ 'dailyCheckin.journal.title' | translate }}
      </h1>
      <p class="journal-sub">{{ 'dailyCheckin.journal.linkSub' | translate }}</p>
    </div>

    <!-- loading / error / empty -->
    <div class="journal-state" *ngIf="journalLoading">
      <mat-icon class="spin">autorenew</mat-icon>
    </div>
    <div
      class="journal-state journal-error"
      *ngIf="!journalLoading && journalError"
    >
      {{ 'dailyCheckin.journal.error' | translate }}
    </div>
    <div
      class="journal-state journal-empty"
      *ngIf="!journalLoading && !journalError && journalDays.length === 0"
    >
      {{ 'dailyCheckin.journal.empty' | translate }}
    </div>

    <ng-container *ngIf="!journalLoading && !journalError && journalDays.length">
      <!-- weekly reflection (structured data only, §5) -->
      <div class="reflect" *ngIf="journalSummaryText">
        <div class="reflect-label">
          {{ 'dailyCheckin.journal.weekLabel' | translate }}
        </div>
        <p class="reflect-text">{{ journalSummaryText }}</p>
      </div>

      <ng-container *ngFor="let day of visibleJournalDays; let i = index">
        <div class="sep" *ngIf="isFirstOfBucket(i)">
          {{ bucketLabelKey(day.bucket) | translate }}
        </div>

        <div class="day-card">
          <div class="day-top">
            <span class="day-date">{{ day.dateLabel }}</span>
            <span class="day-top-right">
              <span class="day-dim" *ngIf="relativeLabelText(day)">
                {{ relativeLabelText(day) }}
              </span>
              <button
                type="button"
                class="day-delete"
                *ngIf="!day.confirmingDelete"
                (click)="askDeleteDay(day)"
                [attr.aria-label]="'dailyCheckin.journal.delete' | translate"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </span>
          </div>

          <div class="day-confirm" *ngIf="day.confirmingDelete">
            <span class="day-confirm-text">
              {{ 'dailyCheckin.journal.deleteConfirm' | translate }}
            </span>
            <span class="day-confirm-actions">
              <button
                type="button"
                class="day-confirm-cancel"
                (click)="cancelDeleteDay(day)"
              >
                {{ 'dailyCheckin.journal.cancel' | translate }}
              </button>
              <button
                type="button"
                class="day-confirm-yes"
                [disabled]="day.deleting"
                (click)="confirmDeleteDay(day)"
              >
                {{ 'dailyCheckin.journal.deleteYes' | translate }}
              </button>
            </span>
          </div>

          <!-- sleep row -->
          <div class="jrow" *ngIf="day.sleepRange">
            <span class="jrow-ico"><mat-icon>bedtime</mat-icon></span>
            <span class="jrow-main">
              <span class="jrow-strong">
                {{ 'dailyCheckin.journal.sleepPrefix' | translate }}
                {{ day.sleepRange }}
              </span>
              <span class="jrow-soft" *ngIf="day.sleepFeeling">
                · {{ day.sleepFeeling }}
              </span>
            </span>
          </div>

          <!-- symptom chips (display only) -->
          <div class="chips" *ngIf="day.chips.length">
            <span class="chip" *ngFor="let c of day.chips">{{ c }}</span>
          </div>

          <!-- free-text quotes -->
          <blockquote class="quote" *ngFor="let q of day.quotes">{{ q }}</blockquote>

          <!-- voice players -->
          <div class="voice-block" *ngFor="let v of day.voices">
            <div class="voice-top">
              <button
                type="button"
                class="voice-play"
                (click)="toggleVoice(v)"
                [attr.aria-label]="'dailyCheckin.journal.playAria' | translate"
              >
                <mat-icon *ngIf="v.loadingAudio" class="spin">autorenew</mat-icon>
                <mat-icon *ngIf="!v.loadingAudio">
                  {{ isPlaying(v) ? 'pause' : 'play_arrow' }}
                </mat-icon>
              </button>
              <span class="wave" [class.playing]="isPlaying(v)">
                <span style="height: 30%"></span>
                <span style="height: 60%"></span>
                <span style="height: 85%"></span>
                <span style="height: 45%"></span>
                <span style="height: 95%"></span>
                <span style="height: 55%"></span>
                <span style="height: 35%"></span>
                <span style="height: 75%"></span>
                <span style="height: 50%"></span>
                <span style="height: 88%"></span>
                <span style="height: 40%"></span>
                <span style="height: 65%"></span>
              </span>
              <span class="voice-dur" *ngIf="v.durationMs">
                {{ formatDuration(v.durationMs) }}
              </span>
            </div>

            <div class="voice-tr" *ngIf="!v.editing">
              <span class="voice-tr-lbl">
                {{ 'dailyCheckin.journal.autoTranscript' | translate }}
              </span>
              <span class="voice-tr-text" *ngIf="v.transcript">
                {{ v.transcript }}
              </span>
              <span class="voice-tr-fail" *ngIf="!v.transcript">
                {{ 'dailyCheckin.journal.transcriptFailed' | translate }}
              </span>
              <button
                type="button"
                class="voice-edit-btn"
                *ngIf="v.transcript"
                (click)="startEditTranscript(v)"
              >
                <mat-icon>edit</mat-icon>
                <span>{{ 'dailyCheckin.journal.editTranscript' | translate }}</span>
              </button>
            </div>

            <div class="voice-edit" *ngIf="v.editing">
              <textarea
                class="voice-edit-area"
                [(ngModel)]="v.draft"
                rows="3"
              ></textarea>
              <div class="voice-edit-actions kb-lift">
                <button
                  type="button"
                  class="voice-cancel"
                  (click)="cancelEditTranscript(v)"
                >
                  {{ 'dailyCheckin.journal.cancel' | translate }}
                </button>
                <button
                  type="button"
                  class="voice-save"
                  [disabled]="savingTranscript"
                  (click)="saveTranscript(v)"
                >
                  {{ 'dailyCheckin.journal.save' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <button
        type="button"
        class="load-more"
        *ngIf="hasMoreDays"
        (click)="showMoreDays()"
      >
        {{ 'dailyCheckin.journal.loadMore' | translate }}
      </button>
    </ng-container>
  </section>

</div>
